import { render, staticRenderFns } from "./catalogs.vue?vue&type=template&id=522955ad"
import script from "./catalogs.vue?vue&type=script&lang=js"
export * from "./catalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports